var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 27.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M57.25,30 A27.25,27.25,0,1,0,2.75,30 A27.25,27.25,0,1,0,57.25,30Z M52.75,30 A22.75,22.75,0,1,0,7.25,30 A22.75,22.75,0,1,0,52.75,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42.25,30 A12.25,27.25,0,1,0,17.75,30 A12.25,27.25,0,1,0,42.25,30Z M37.75,30 A7.75,22.75,0,1,0,22.25,30 A7.75,22.75,0,1,0,37.75,30Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    clipPath: "url(#g)",
    x: 2.75,
    y: 27.75,
    width: 54.5,
    height: 4.5
  })));
};
export default SvgGlobe;